import { useEffect, useState, useCallback } from "react";
import { CommonPropertyProps, PopulatesData } from "schemas/elements";
import SearchSelectContainer from "components/FormDesigner/elements/SearchSelect/SearchSelectContainer";
import api from "lib/api";
import { useTranslation } from "react-i18next";
import { status } from "../../../../constants";
import axios from "axios";
import { AlertProps, SearchSelectOptionProps } from "@alm/flow-ds/components";

type Props = Omit<CommonPropertyProps, "value"> & {
	value: SearchSelectOptionProps;
	populatesFrom?: SearchSelectOptionProps;
	populatesData?: PopulatesData[];
	addAlert: (alert: string, status: AlertProps["status"]) => void;
	canPopulate?: boolean;
};

export default ({
	updateStore,
	field,
	required,
	value,
	desc,
	populatesFrom,
	populatesData,
	validation,
	elementIndex,
	addAlert,
	canPopulate,
	isEmu,
}: Props) => {
	const { t } = useTranslation();
	const [path, setPath] = useState<SearchSelectOptionProps[]>([]);
	const [populatesFromPath, setPopulatesFromPath] = useState<
		string | undefined
	>("PathThatCanNeverHappen");
	const [loading, setLoading] = useState<boolean>(false);

	const [init, setInit] = useState(false);

	const getKeys = useCallback(async () => {
		// Gets list of keys taken from the entity in populatesFrom's elements request-uri
		try {
			setLoading(true);
			const res = await api.entity.getEntityData(
				populatesFromPath as string
			);
			if (res !== undefined) {
				setPath(res);
			}
		} catch (error) {
			addAlert("errorLoadingFormList", status.ERROR);
			if (error && axios.isAxiosError(error))
				console.error(`Error: ${error.message}`);
		}
		setLoading(false);
	}, [populatesFromPath, addAlert]);

	useEffect(() => {
		if (
			populatesFrom !== undefined &&
			populatesFrom !== null &&
			populatesData !== undefined &&
			populatesData.length > 0
		) {
			populatesData.forEach(populates => {
				if (populates.from === populatesFrom.value) {
					const tempPath = populates.key?.value.substr(
						populates.key?.value.lastIndexOf("/") + 1
					);
					if (populatesFromPath !== tempPath)
						setPopulatesFromPath(
							populates.key?.value.substr(
								populates.key?.value.lastIndexOf("/") + 1
							)
						);

					if (populates.key === undefined && path.length > 0)
						setPath([]);
				}
			});
		} else if (
			(populatesFrom === null || populatesFrom === undefined) &&
			value !== undefined &&
			value !== null &&
			init
		) {
			updateStore({
				elementIndex,
				property: field,
				value: null,
			});
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [getKeys, populatesFrom, populatesData]);

	useEffect(() => {
		if (
			populatesFromPath !== undefined &&
			populatesFromPath !== null &&
			populatesFromPath !== "PathThatCanNeverHappen"
		) {
			getKeys();
		} else if (
			(populatesFromPath !== "PathThatCanNeverHappen" ||
				populatesFrom === null ||
				populatesFrom === undefined) &&
			init
		) {
			const emptyArray: SearchSelectOptionProps[] = [];
			setPath(emptyArray);
			updateStore({
				elementIndex,
				property: field,
				value: null,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [populatesFromPath]);

	useEffect(() => {
		if (!canPopulate && value !== undefined && value !== null && init)
			updateStore({
				elementIndex,
				property: field,
				value: null,
			});
		else setInit(true);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [canPopulate]);

	const props = {
		updateStore,
		field,
		required,
		value,
		validation,
		desc,
		elementIndex,
		loading,
		disabled: path.length && populatesFrom ? false : true,
		disabledPlaceholder: loading
			? undefined
			: populatesFrom !== undefined && populatesFrom !== null
			? t("formDesigner.placeholders.populatesKeyRelation", {
					from: populatesFrom.label,
			  })
			: t("formDesigner.placeholders.populatesKeyRelation2"),
		creatable: true,
		monospaceFont: !isEmu,
	};

	if (canPopulate) return <SearchSelectContainer {...props} options={path} />;
	else return <></>;
};
